import React from 'react';
import FormDialog from '../../../library/form/components/FormDialog';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel';
import FormRichText from '../../../library/form/components/FormRichText';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormTitle from '../../../library/form/components/FormTitle';
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormDropDown from '../../../library/form/components/FormDropDown';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvExpItemDetailEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '500px' }}
            contentStyle={{ height: '400px', width: "730px" }}
            formTitle={<FormTitle formObject={formObject} value='Order Item' />}
            formObject={formObject} > 
            <div className="uiitemDetailMain" >

                <div className="uiROHeader">
                    <div style={{ display: "inline-block" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} value="Item" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "itemIdReadOnly" }} className='uiVal' />
                    </div>
                    <div style={{ display: "inline-block" }} >
                        <span className="uiLblInLine">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemMaster" }} value="Item" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "130px" }} placeholder="Item Name..."
                            action={{ InputType: "ac", paramName: "itemMaster", acMethod: "Item", acDepCtrl: { dtid: '%dataList.valLDT', level: 1 } }}
                        />

                        <FormInput formObject={formObject} rowKey="" className="" style={{ width: "70px" }} placeholder="From..."
                            action={{ InputType: "input", paramName: "itemFromLoc" }}
                        />

                        <FormInput formObject={formObject} rowKey="" className="" style={{ width: "70px" }} placeholder="To..."
                            action={{ InputType: "input", paramName: "itemToLoc" }}
                        />

                        <FormInput formObject={formObject} rowKey="" className="uiInput" style={{ width: "70px" }} placeholder="Vehicle No..."
                            action={{ InputType: "ac", paramName: "itemVehicle", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                        />

                        <FormButton formObject={formObject} rowKey="" className="uiActionButton" text={<SarasTrans value="Update Item" />}
                            action={{ actionId: "refresh",  actionParam: { changeitem: 1 } }}
                        />
                    </div>
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "itemQtyContainer" }} >
                    <div>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty1" }} value="Quantity" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                            action={{ InputType: "input", actionId: "refresh", paramName: "qty1", actionParam: { formulaSource: "QT1", updateNetAmount: "1" } }} />
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty1uom" }} />
                        <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey="" action={{ paramName: "itemQty2Container" }} >
                            <span className="uiLblInLine">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qty2" }} value="and" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                action={{ InputType: "input", actionId: "refresh", paramName: "qty2", actionParam: { formulaSource: "QT2", updateNetAmount: "1" } }} />
                            <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "qty2uom" }} />
                        </FormWrapper>
                    </div>
                </FormWrapper>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "itemCostContainer2" }} >
                    <ul className="uiItemPopupForm">
                        <li>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unitPrice" }} value="Claim Amount" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" maxlength="24"
                                    action={{ InputType: "input", actionId: "refresh", paramName: "unitPrice", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                <span className="uiLblInLine">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sellPriceUnit" }} value="per" />
                                </span>
                                <FormDropDown formObject={formObject} rowKey="" action={{ actionId: "refresh", paramName: "sellPriceUnit", actionParam: { formulaSource: "UP", updateNetAmount: "1" } }} />
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priceUnit" }} className='uiVal' />
                            </div>
                            <div className="uiColumn">
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} value="Total Amount" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "amtAfterQC" }} className='uiVal' />
                            </div>
                        </li>
                    </ul>
                </FormWrapper>
                <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "sectionMiscContainer" }} >
                    <ul className="uiItemPopupForm">
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNo" }} value="Reference No" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className=""
                                action={{ InputType: "input", paramName: "refNo" }}
                            />
                        </li>
                        <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "itemName" }} >
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemName" }} value="Reference Name" />
                            </span>
                            <FormInput formObject={formObject} rowKey="" className="uiInputLong"
                                action={{ InputType: "input", paramName: "itemName" }}
                            />
                        </FormWrapper>
                        <li>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "itemDesc" }} value="Material Detail" />
                            </span>
                            <FormRichText formObject={formObject} rowKey="" id="delInstTxt" className="uiFrmText" rows="3" cols="82" maxlength="1000"
                                action={{ paramName: "itemDesc" }}
                            />
                        </li>
                    </ul>
                </FormWrapper>
            </div>
        </FormDialog>
    )
}

export default withView(InvExpItemDetailEditor, "itemDetail", "itemDetail")